import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuth } from '../context/AuthContext';
import Navbar from '../utils/Navbar';
import { setFilter } from '../redux/filterState';
import {useDispatch, useSelector} from "react-redux";

const Profil = () => {
  const { fetchWithAuth, accessToken, mandantName } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [profil, setProfil] = useState(null);
  const [kategorien, setKategorien] = useState([]);
  const [selectedDefault, setSelectedDefault] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: ''
  });

  const [editMode, setEditMode] = useState(false);

  const onCancel = () => {
    // reset form to original values
    setFormData({
      username: profil.username || '',
      email: profil.email || '',
      first_name: profil.first_name || '',
      last_name: profil.last_name || ''
    });

    setEditMode(false);
  };

  const onSave = async () => {
    try {
      const res = await fetchWithAuth('/api/usr/profil/', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!res.ok) throw new Error("Save failed");

      const updatedProfil = await res.json();

      setProfil(updatedProfil);
      setEditMode(false);
    } catch (err) {
      console.error("Fehler beim Speichern:", err);
    }
  };

  const onBack = () => {
    navigate('/objekte');
  };
  
  const filters = useSelector(state => state.filters);

  // Fetch user profile + user settings
  useEffect(() => {
    if (!accessToken) return;

    const fetchProfilAndSettings = async () => {
      try {
        const [profilRes, settingsRes, kategorienRes] = await Promise.all([
          fetchWithAuth(`/api/usr/profil/`, {
            headers: {
              'Content-Type': 'application/json'
            }
          }),
          fetchWithAuth(`/api/usr/settings/`, {
            headers: {
              'Content-Type': 'application/json'
            }
          }),
          fetchWithAuth(`/api/data/kategorien/`, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
        ]);

        if (!profilRes.ok || !settingsRes.ok || !kategorienRes.ok) {
          throw new Error('Fehler beim Laden der Daten');
        }

        const profilData = await profilRes.json();
        const settingsData = await settingsRes.json();
        const kategorienData = await kategorienRes.json();

        setProfil(profilData);

        setFormData({
          username: profilData.username || '',
          email: profilData.email || '',
          first_name: profilData.first_name || '',
          last_name: profilData.last_name || ''
        });

        setSelectedDefault(settingsData.default_kategorie || '');
        setKategorien(kategorienData || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfilAndSettings();
  }, [accessToken]);

  // Update default_kategorie in backend
  const saveDefaultKategorie = async (newValue) => {
    try {
      await fetchWithAuth(`/api/usr/settings/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ default_kategorie: newValue })
      });

      // update redux filter manually
      const updatedFilters = {
        ...filters,
        kategorie: newValue,
        defaultKategorie: newValue
      };
  
      sessionStorage.setItem("lastKnownListState", JSON.stringify(updatedFilters));
      
    } catch (err) {
      console.error('Fehler beim Speichern der Einstellung:', err);
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    saveDefaultKategorie(newValue);
    setSelectedDefault(newValue);
    dispatch(setFilter("kategorie", newValue)); // Set Redux filter
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const renderField = (label, name) => (
    <div className="row mb-3">
      <div className="col-sm-4 fw-bold">{label}:</div>
      <div className="col-sm-8">
        {editMode ? (
          <input
            type="text"
            className="form-control"
            name={name}
            value={formData[name]}
            onChange={handleInputChange}
          />
        ) : (
          formData[name] || "-"
        )}
      </div>
    </div>
  );

  if (loading) return <div className="container mt-5">Lade Profildaten...</div>;
  if (error) return <div className="container mt-5 text-danger">Fehler: {error}</div>;

  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <h2 className="mb-4">Mein Profil</h2>
        <div className="card shadow p-4">
          <div className="row mb-3">
            <div className="col-sm-4 fw-bold">Mandant:</div>
            <div className="col-sm-8">{mandantName}</div>
          </div>
          {renderField("Benutzername", "username")}
          {renderField("E-Mail", "email")}
          {renderField("Vorname", "first_name")}
          {renderField("Nachname", "last_name")}

          <div className="row mb-3">
            <div className="col-sm-4 fw-bold">Standard-Kategorie:</div>
            <div className="col-sm-8">
              <select className="form-select" value={selectedDefault} onChange={handleChange}>
                <option value="">Keine Standard-Kategorie</option>
                {kategorien.map(k => (
                  <option key={k.id} value={k.id}>{k.name}</option>
                ))}
              </select>
            </div>
          </div>

          {/* buttons */}
          <div className="mt-4 d-flex flex-wrap gap-2">
            {editMode ? (
            <>
              <button className="btn btn-warning" onClick={onCancel}>Abbrechen</button>
              <button className="btn btn-success" type="button" onClick={onSave}>Speichern</button>
            </>
            ) : (
            <>
              <button className="btn btn-secondary" onClick={onBack}>Zurück</button>
              <button className="btn btn-primary" type="button" onClick={() => setEditMode(true)}>Bearbeiten</button>
            </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Profil;
